import React, { useState, useEffect, useContext, useRef } from "react";
import facebook from "../Images/facebook.png";
import instagram from "../Images/instagram.png";
import { Flex, Input } from "antd";
import { useHistory } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../Images/CloseImg.png";
import { useTranslation } from "react-i18next";
import { AppContext, useAppContext } from "../AppContext";

import { MyDomain } from "../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1440
        ? "50%"
        : window.innerWidth <= 1920
        ? "30%"
        : window.innerWidth <= 2560
        ? "50%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function BottomBlock() {
  const { Lang, setLang } = useAppContext();

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const lang = JSON.parse(localStorage.getItem("lang")) ?? JSON.stringify("en");
  const [Choosing, setChoosing] = useState(lang);
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const history = useHistory();
  const handleDivClick = (CategoryName) => {
    history.push(`/${CategoryName}`);
  };
  const SubscribeButton = () => {
    EmailSubsFunc();
  };
  const [openCart, setOpenCart] = useState(false);

  const [openDone, setOpenDone] = useState(false);

  const [openEmailSubsDone, setOpenEmailSubsDone] = useState(false);

  const handleClose = () => {
    setOpenCart(false);
  };

  const handleClose2 = () => {
    setOpenDone(false);
  };

  const handleClose3 = () => {
    setOpenEmailSubsDone(false);
  };

  const [FirstName, setFirstName] = useState("");
  const [PhoneNumber, setPhoneNumber] = useState("");
  const [TheText, setTheText] = useState("");

  const [PhoneNumberDataBase, setPhoneNumberDataBase] = useState("");
  const prefix = "+972";

  const handlePhoneChange = (e) => {
    let inputValue = e.target.value;

    // Ensure the input starts with the prefix
    if (!inputValue.startsWith(prefix)) {
      inputValue = prefix;
    }

    // Extract the digits after the prefix
    let phoneDigits = inputValue.slice(prefix.length);

    // Remove extra spaces
    phoneDigits = phoneDigits.replace(/\s+/g, "");

    // Limit to max length (excluding prefix)
    if (phoneDigits.length > 9) {
      phoneDigits = phoneDigits.slice(0, 9); // 9 digits after prefix
    }

    // Format: Insert a space after the first two digits
    if (phoneDigits.length > 2) {
      phoneDigits = phoneDigits.slice(0, 2) + " " + phoneDigits.slice(2);
    }

    // Update state
    setPhoneNumberDataBase(prefix + phoneDigits.replace(/\s+/g, "")); // Store without spaces
    setPhoneNumber(prefix + " " + phoneDigits);
  };

  const handleFocus = () => {
    if (!PhoneNumber.startsWith(prefix)) {
      setPhoneNumber(prefix);
    }
  };

  const CreateCallBack = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      FullName: FirstName,
      PhoneNumber: PhoneNumber,
      Text: TheText,
      IsRead: 0,
    };
    axios
      .post(`${MyDomain}CallBack/CreateCallBack`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
        setOpenDone(true);
        setOpenCart(false);
        setFirstName("");
        setPhoneNumber("");
        setTheText("");
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  function ModalDone() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={openDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            {/* <IconButton
              aria-label="close"
              onClick={handleClose2}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            ></IconButton> */}

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>{t("profile.Greatwewillcontactyouassoonaspossible")}</a>
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                    marginTop: 40,
                  }}
                  onClick={() => {
                    handleClose2();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Done")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }

  function ModalEmailSubs() {
    return (
      <div>
        <React.Fragment>
          <BootstrapDialog
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={openEmailSubsDone}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <IconButton
              aria-label="close"
              onClick={handleClose3}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(15vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <a>Great, you will be first who receive newsletter!</a>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }
  function Modal() {
    return (
      <div>
        <React.Fragment>
          {/* <Button variant="outlined" onClick={handleClickOpen}>
          Open dialog
        </Button> */}
          <BootstrapDialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={openCart}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
              {t("profile.WEWILLCALLYOUBACK")}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "calc(50vh - 55px)",
                  minHeight: "calc(60vh - 55px)",
                  padding: 20,
                  //backgroundColor: "red",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextField
                  id="standard-basic"
                  label={t("profile.Fullname")}
                  variant="standard"
                  style={{
                    paddingBottom: 20,
                    width: "100%",
                  }}
                  InputLabelProps={{
                    style: {
                      opacity: 0.5,
                      fontSize: "15px",
                    }, // Apply opacity to the label
                  }}
                  value={FirstName} // Bind the state value to the TextField
                  onChange={(e) => setFirstName(e.target.value)} // Update state on input change
                />

                <TextField
                  id="standard-basic"
                  label={t("profile.Phone")}
                  variant="standard"
                  style={{ paddingBottom: 35, width: "100%" }}
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" },
                  }}
                  value={PhoneNumber}
                  onChange={handlePhoneChange}
                  onFocus={handleFocus}
                  maxLength={14} // Prevents entering more than 14 characters
                />

                <TextField
                  style={{ paddingBottom: 20, width: "100%" }}
                  id="standard-multiline-static"
                  label={t("profile.Messagetext")}
                  multiline
                  rows={4}
                  //defaultValue="Default Value"
                  variant="standard"
                  InputLabelProps={{
                    style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                  }}
                  onChange={(e) => setTheText(e.target.value)} // Update state on input change
                  value={TheText}
                />
                <button
                  style={{
                    marginTop: 20,
                    backgroundColor: "#27272a",
                    color: "#fff",
                    border: "none",
                    //padding: "10px 20px",
                    cursor: "pointer",
                    fontSize: "16px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: 50,
                  }}
                  onClick={() => {
                    CreateCallBack();
                  }}
                >
                  <a style={{ fontSize: 14 }}>{t("profile.Send")}</a>
                </button>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </div>
    );
  }

  function MobileDrawer() {
    return (
      <>
        <Drawer
          open={openCart}
          onClose={handleClose}
          anchor="bottom"
          PaperProps={{
            style: {
              height: "auto", // Height adjusts to content
              //maxHeight: "90vh", // Optional: Limit max height
              overflow: "auto", // Enable scrolling
              //height: "100vh", // Set height to 100% of the viewport height
            },
          }}
        >
          <div
            style={{
              display: "flex",
              paddingBottom: 20,
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: "2%",
              paddingLeft: "2%",
              paddingTop: 15,
              direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
            }}
          >
            <a style={{ fontSize: 20 }}>{t("profile.WEWILLCALLYOUBACK")}</a>
            <img
              onClick={() => {
                handleClose();
              }}
              src={CloseImg}
              alt={"Expand"}
              style={{
                width: 25,
                height: 25,
                cursor: "pointer",
              }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "calc(50vh - 55px)",
                minHeight: "calc(60vh - 55px)",
                padding: 20,
                //backgroundColor: "red",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <TextField
                id="standard-basic"
                label={t("profile.Fullname")}
                variant="standard"
                style={{ paddingBottom: 20, width: "100%" }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                }}
                value={FirstName} // Bind the state value to the TextField
                onChange={(e) => setFirstName(e.target.value)} // Update state on input change
              />

              <TextField
                id="standard-basic"
                label={t("profile.Phone")}
                variant="standard"
                style={{ paddingBottom: 35, width: "100%" }}
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" },
                }}
                value={PhoneNumber}
                onChange={handlePhoneChange}
                onFocus={handleFocus}
                maxLength={14} // Prevents entering more than 14 characters
              />

              <TextField
                style={{ paddingBottom: 20, width: "100%" }}
                id="standard-multiline-static"
                label={t("profile.Messagetext")}
                multiline
                rows={4}
                //defaultValue="Default Value"
                variant="standard"
                InputLabelProps={{
                  style: { opacity: 0.5, fontSize: "15px" }, // Apply opacity to the label
                }}
                onChange={(e) => setTheText(e.target.value)} // Update state on input change
                value={TheText}
              />
              <button
                style={{
                  marginTop: 20,
                  backgroundColor: "#27272a",
                  color: "#fff",
                  border: "none",
                  //padding: "10px 20px",
                  cursor: "pointer",
                  fontSize: "16px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 50,
                }}
                onClick={() => {
                  CreateCallBack();
                }}
              >
                <a style={{ fontSize: 14 }}>{t("profile.Send")}</a>
              </button>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
  const [hoveredId, setHoveredId] = useState(null);

  const allLinks = [
    {
      id: 1,
      label: t("navigation.Aboutus"),
      onClick: () => {
        handleDivClick("about-us");
        scrollToTop();
      },
    },
    {
      id: 2,
      label: t("profile.Contactus"),
      onClick: () => {
        handleDivClick("feedback");
        scrollToTop();
      },
    },
    { id: 3, label: t("profile.Termsofuse") },
    { id: 4, label: t("profile.Privacy") },
    //{ id: 5, label: "App" },
  ];

  const secondColumnLinks = [
    {
      id: 6,
      label: t("profile.Shipping"),
      onClick: () => {
        handleDivClick("delivery");
        scrollToTop();
      },
    },
    { id: 7, label: t("profile.Aboutourproducts") },
    { id: 8, label: t("profile.ReturnsandExchanges") },
  ];

  const thirdColumnLinks = [
    {
      id: 9,
      label: t("profile.Articles"),
      onClick: () => {
        handleDivClick("articles");
        scrollToTop();
      },
    },
    {
      id: 10,
      label: t("profile.News"),
      onClick: () => {
        handleDivClick("news");
        scrollToTop();
      },
    },
    {
      id: 11,
      label: "Beauty Club",
      onClick: () => {
        handleDivClick("beauty-club");
        scrollToTop();
      },
    },
  ];

  const baseStyle = {
    fontSize: 14,
    paddingBottom: 10,
    cursor: "pointer",
  };
  const [Email, setEmail] = useState("");
  // Example: Tel Aviv coordinates
  const latitude = 32.49285;
  const longitude = 35.08549;

  //const wazeUrl = `https://waze.com/ul?ll=${latitude},${longitude}&navigate=yes`;
  const wazeUrl = `waze://?ll=${latitude},${longitude}&navigate=yes`;

  const ContactSection = () => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            //paddingBottom: 50,
            width: MyWidth <= 1024 ? "100%" : "none",
            justifyContent: MyWidth <= 1024 ? "center" : "none",
            alignItems: MyWidth <= 1024 ? "center" : "none",
          }}
        >
          <a
            style={{
              paddingBottom: 15,
              fontWeight: "600",
              fontSize: 20,
              //direction: i18n.resolvedLanguage === "en" ? "" : "ltr",
            }}
          >
            {i18n.resolvedLanguage === "en" ? (
              <>+972 52-747-7128</>
            ) : (
              <>52-747-7128 972+</>
            )}
          </a>
          {MyWidth <= 1024 ? (
            <></>
          ) : (
            <>
              <a style={{ fontSize: 14, paddingTop: 10, paddingBottom: 5 }}>
                <a style={{ opacity: 0.5 }}>{t("sentence.Youcan")} </a>
                <a
                  onClick={() => {
                    handleDivClick("feedback");
                    scrollToTop();
                  }}
                  style={{
                    color: "#6b21a8",
                    cursor: "pointer",
                  }}
                >
                  {t("sentence.emailus")}{" "}
                </a>
                <a style={{ opacity: 0.5, fontSize: 14 }}>
                  {t("sentence.callus")}
                </a>
              </a>
            </>
          )}

          <a style={{ opacity: 0.5, fontSize: 14 }}>{t("profile.SunFri")}</a>
          <a
            href={wazeUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: 14, fontWeight: "bold", paddingTop: 10 }}
          >
            {t("profileOrderHistory.Place")}
          </a>

          <a
            style={{
              //opacity: 0.5,
              paddingTop: 20,
              fontSize: 14,
              color: "#6b21a8",
              cursor: "pointer",
            }}
            onClick={() => {
              setOpenCart(true);
            }}
          >
            {t("profile.Callback")}
          </a>

          {/* (Arabic, Hebrew, English speaking staff)*/}
        </div>
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <>
            <div
              style={{
                justifyContent: "space-between",
                flexDirection: "row",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: 20,
                }}
              >
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 14,
                    color: Lang === "he" ? "black" : "#a1a1aa",
                    cursor: "pointer",
                    fontWeight: Lang === "he" ? "bold" : "",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("he");
                    changeLanguage("he");
                    localStorage.setItem("lang", JSON.stringify("he"));
                  }}
                >
                  עברית
                </p>
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 14,
                    cursor: "pointer",
                    color: Lang === "ar" ? "black" : "#a1a1aa",
                    fontWeight: Lang === "ar" ? "bold" : "",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("ar");
                    changeLanguage("ar");
                    localStorage.setItem("lang", JSON.stringify("ar"));
                  }}
                >
                  العربية
                </p>
                <p
                  style={{
                    margin: 5,
                    padding: 0,
                    fontSize: 14,
                    cursor: "pointer",
                    color: Lang === "en" ? "black" : "#a1a1aa",
                    fontWeight: Lang === "en" ? "bold" : "",
                  }}
                  onClick={() => {
                    setChoosing(lang);
                    setLang("en");

                    changeLanguage("en");
                    localStorage.setItem("lang", JSON.stringify("en"));
                  }}
                >
                  English
                </p>
              </div>
            </div>
          </>
        )}
      </>
    );
  };
  const [EmailErr, setEmailErr] = useState(false);

  const EmailSubsFunc = () => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    regex.test(Email);
    if (regex.test(Email)) {
      setEmailErr(false);
    } else {
      setEmailErr(true);
    }

    if (!regex.test(Email)) {
      return;
    }
    const data = {
      Email: Email,
    };

    axios
      .post(`${MyDomain}EmailsSubs/CreateEmailsSubs`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
        //setEmail("");
        setOpenEmailSubsDone(true);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  return (
    <div
      style={{
        paddingTop: 100,
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
      }}
    >
      {ModalDone()}
      {ModalEmailSubs()}
      {MyWidth <= 1024 ? <>{MobileDrawer()}</> : <>{Modal()}</>}

      <div
        style={{
          height: 400,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#fafafa",
          flexDirection: "column",
        }}
      >
        <p style={{ fontSize: MyWidth <= 1024 ? 15 : 25, fontWeight: 500 }}>
          {t("profile.Bethefirsttoknowaboutsalesandnewarrivals")}
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: MyWidth <= 1024 ? "80%" : "25%",
            justifyContent: "space-between",
            alignItems: "center",
            //direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
          }}
        >
          <TextField
            id="standard-basic"
            label={t("profile.email")}
            variant="standard"
            style={{ paddingBottom: 30, width: "100%", fontSize: 10 }}
            InputLabelProps={{
              style: { color: "#a1a1aa", fontSize: "14px" }, // Make label text black
            }}
            value={Email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              "& .MuiInput-underline:before": {
                borderBottomColor: "#a1a1aa", // Default color for bottom line
                opacity: 0.5,
                borderBottomWidth: "1px", // Thin bottom line
              },
              "& .MuiInput-underline:hover:before": {
                borderBottomColor: "#a1a1aa", // Keep it gray on hover
                opacity: 0.8,
                borderBottomWidth: "1px", // Keep it thin on hover
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#6366f1", // Change to yellow on focus
                borderBottomWidth: "1px", // Keep it thin when focused
              },
              "& .MuiInputBase-root": {
                //color: "#a1a1aa", // Color of the text in the input field
                fontSize: "14px", // Set font size of entered value to 14px
              },
            }}
          />
          <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f4f4f5",
              //color: "white",
              //padding: "10px 20px",
              border: "none",
              cursor: "pointer",
              marginBottom: 10,
            }}
            onClick={SubscribeButton}
          >
            <p style={{ fontSize: 15, margin: 0 }}>{t("profile.subscribe")}</p>
          </button>

          <div
            style={{
              //justifyContent: "center",
              //alignItems: "center",
              display: "flex",
            }}
          ></div>
        </div>
        {EmailErr ? (
          <div
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            <a style={{ fontSize: 14, color: "red" }}>
              Please check your email
            </a>
          </div>
        ) : (
          <></>
        )}
        {/* <div
          style={{
            marginTop: 5,
            border: "1px solid black",
            width: "25%",
            marginBottom: 50,
          }}
        ></div> */}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div
            style={{
              border: "1px solid #e4e4e7",
              padding: MyWidth <= 1024 ? 10 : 15,
              borderRadius: "50%",
              display: "flex",
              marginRight: 20,
              marginLeft: i18n.resolvedLanguage === "en" ? 0 : 20,
              cursor: "pointer",
            }}
            onClick={() =>
              window.open(
                "https://www.facebook.com/profile.php?id=61576583160431",
                "_blank"
              )
            }
          >
            <img
              src={facebook}
              alt="logo"
              style={{
                minWidth: MyWidth <= 1024 ? "15px" : "20px",
                height: MyWidth <= 1024 ? "15px" : "20px",
              }}
            />
          </div>
          <div
            style={{
              border: "1px solid #e4e4e7",
              padding: MyWidth <= 1024 ? 10 : 15,
              borderRadius: "50%",
              display: "flex",
              cursor: "pointer",
            }}
            onClick={() =>
              window.open("https://www.instagram.com/lemaq.store/", "_blank")
            }
          >
            <img
              src={instagram}
              alt="logo"
              style={{
                minWidth: MyWidth <= 1024 ? "15px" : "20px",
                height: MyWidth <= 1024 ? "15px" : "20px",
              }}
            />
          </div>
        </div>
      </div>
      {MyWidth <= 1024 ? (
        <>
          <div
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            {ContactSection()}
          </div>
        </>
      ) : (
        <></>
      )}

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          paddingTop: MyWidth <= 1024 ? 30 : 100,
        }}
      >
        {/* Column 1 */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {allLinks.map(({ id, label, onClick }) => (
            <a
              key={id}
              onMouseEnter={() => setHoveredId(id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={onClick}
              style={{
                ...baseStyle,
                color: hoveredId === id ? "#6b21a8" : "black",
              }}
            >
              {label}
            </a>
          ))}
        </div>

        {/* Column 2 */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {secondColumnLinks.map(({ id, label, onClick }) => (
            <a
              key={id}
              onMouseEnter={() => setHoveredId(id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={onClick}
              style={{
                ...baseStyle,
                color: hoveredId === id ? "#6b21a8" : "black",
              }}
            >
              {label}
            </a>
          ))}
        </div>

        {/* Column 3 (With Clickable News) */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {thirdColumnLinks.map(({ id, label, onClick }) => (
            <a
              key={id}
              onMouseEnter={() => setHoveredId(id)}
              onMouseLeave={() => setHoveredId(null)}
              onClick={onClick}
              style={{
                ...baseStyle,
                color: hoveredId === id ? "#6b21a8" : "black",
              }}
            >
              {label}
            </a>
          ))}
        </div>
        {MyWidth <= 1024 ? <></> : <>{ContactSection()}</>}
      </div>
      <div>
        <div
          style={{
            height: "0.1px",
            backgroundColor: "#f4f4f5",
            width: "100%",
          }}
        ></div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingTop: 100,
          flexDirection: "column",
          paddingBottom: 60,
        }}
      >
        <p style={{ fontSize: 14, color: "#6b21a8", fontWeight: 500 }}>
          LEMAQ™. BEAUTY WITHOUT LIMITS
        </p>
        <p style={{ fontSize: 12 }}>© LEMAQ 2024-2025</p>
      </div>
    </div>
  );
}
